var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCartSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 410 410",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "329.221,14.753 293.066,61.697 0,61.697 45.13,295.874 293.773,295.874 326.021,94.721 351.982,61.013 410,61.013 410,14.753 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.533,309.667c-23.596,0-42.791,19.195-42.791,42.79s19.195,42.79,42.791,42.79c23.594,0,42.789-19.195,42.789-42.79 S127.127,309.667,103.533,309.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.779,309.667c-23.596,0-42.789,19.195-42.789,42.79s19.193,42.79,42.789,42.79s42.789-19.195,42.789-42.79 S269.375,309.667,245.779,309.667z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartSvgrepoCom);
export default __webpack_public_path__ + "static/media/shopping-cart-svgrepo-com.8d1afe5d8427dffcdfcf859250f4cd7f.svg";
export { ForwardRef as ReactComponent };